import React from "react";
import Avatar from "../../../node_modules/@material-ui/core/Avatar";
import Button from "../../../node_modules/@material-ui/core/Button";
import CssBaseline from "../../../node_modules/@material-ui/core/CssBaseline";
import Typography from "../../../node_modules/@material-ui/core/Typography";
import { makeStyles } from "../../../node_modules/@material-ui/core/styles";
import Container from "../../../node_modules/@material-ui/core/Container";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Card from "../../../node_modules/@material-ui/core/Card";
import CardContent from "../../../node_modules/@material-ui/core/CardContent";
import Grid from "../../../node_modules/@material-ui/core/Grid";

export default function CashboxMarketing() {
  const useStyles = makeStyles(theme => ({
    paper: {
      marginTop: theme.spacing(4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%"
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
      width: theme.spacing(7),
      height: theme.spacing(7)
    },
    heroTitle: {
      marginTop: theme.spacing(1),
      textAlign: "center"
    },
    subtitle: {
      marginTop: theme.spacing(1),
      textAlign: "center"
    },
    section: {
      width: "100%",
      marginTop: theme.spacing(4)
    },
    card: {
      height: "100%"
    },
    cardTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(1)
    },
    cta: {
      margin: theme.spacing(4, 0, 2)
    },
    disclaimer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4),
      textAlign: "center"
    }
  }));

  const classes = useStyles();

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <MonetizationOnIcon />
        </Avatar>

        <Typography
          component="h1"
          variant="h4"
          className={classes.heroTitle}
        >
          Cashbox Pte Ltd
        </Typography>

        <Typography
          component="h2"
          variant="h6"
          color="primary"
          className={classes.subtitle}
        >
          Cash When You Need It. Value When It Matters.
        </Typography>

        <Typography
          component="p"
          variant="body1"
          color="textSecondary"
          className={classes.subtitle}
        >
          A simple and professional way to unlock the value of your
          valuables.
        </Typography>

        <div className={classes.section}>
          <Typography component="h2" variant="h5" align="center">
            What We Accept
          </Typography>

          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h6" className={classes.cardTitle}>
                    Gold & Jewellery
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Gold, jewellery and selected valuable items.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h6" className={classes.cardTitle}>
                    Luxury Watches
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Selected branded and luxury watches.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h6" className={classes.cardTitle}>
                    Electronics
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Selected electronics and valuable items.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h6" className={classes.cardTitle}>
                    Other Valuables
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Bring your item in for assessment.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>

        <div className={classes.section}>
          <Typography component="h2" variant="h5" align="center">
            Why Cashbox?
          </Typography>

          <Typography
            component="p"
            variant="body1"
            align="center"
            className={classes.subtitle}
          >
            Fast service, clear explanations and a professional approach.
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>FAST CASH</strong> — Quick assessment and straightforward
            service.
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>FAIR VALUE</strong> — Professional assessment of your
            item.
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>SIMPLE PROCESS</strong> — Clear terms before you decide.
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>PRIVATE & PROFESSIONAL</strong> — Your transaction is
            handled with care.
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography component="h2" variant="h5" align="center">
            How It Works
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>01 — Bring It In</strong>
            <br />
            Bring your item to Cashbox for assessment.
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>02 — Get Valued</strong>
            <br />
            Our team assesses the item and explains the available offer.
          </Typography>

          <Typography component="p" variant="body1" align="center">
            <strong>03 — Get Your Cash</strong>
            <br />
            Accept the offer and receive your cash according to the applicable
            terms.
          </Typography>
        </div>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          className={classes.cta}
        >
          Visit Cashbox Today
        </Button>

        <Typography
          component="p"
          variant="caption"
          color="textSecondary"
          className={classes.disclaimer}
        >
          Terms and conditions apply. Valuation and loan amount are subject
          to assessment.
        </Typography>
      </div>
    </Container>
  );
}
